<template>
  <div class="verification-page">
    <!-- <el-row type="flex" justify="center" align="middle" class="m-t-3">
    <el-col :span="6"> -->
    <h4 class="t-c font-normal">Confirm Verification</h4>
    <!-- <el-card class="t-c"> -->
    <p class="m-t t-c">A verification code is send to your email address.</p>
    <p class="m-b-2 t-c">Please enter code to verify your email.</p>

    <el-form
      ref="verifyForm"
      :model="user"
      :rules="rules"
      :show-message="false"
      :status-icon="true"
      @submit.native="onSubmit">
      <el-form-item prop="code">
        <el-input
          v-model="user.code"
          placeholder="1234567"/>
      </el-form-item>
      <el-row
        type="flex"
        justify="center"
        class="m-t-2">
        <el-button
          v-loading="loading"
          type="primary"
          @click="onSubmit">Verify Now</el-button>
        <el-button
          type="plain"
          @click="onResend">Send Again</el-button>
      </el-row>
      <div class="t-c m-t">
        <p>Don't have an account? &nbsp;<router-link to="/signup">Sign Up</router-link></p>
      </div>
    </el-form>
    <!-- </el-card> -->
    <!-- </el-col>
  </el-row> -->
  </div>
</template>

<script>
import User from '../../services/User';

export default {
  name: 'VerificationPage',
  data() {
    return {
      userProvider: null,
      user: {
        username: '',
        code: '',
      },
      rules: {
        code: { required: true, message: 'Verification code required', trigger: 'change' },
      },
      loading: false,
    };
  },
  mounted() {
    this.userProvider = new User();

    const user = this.userProvider.getCurrentUser();
    this.user.username = user.username || '';

    window.eventBus.$emit('onboarding-step-change', 0);
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.$refs.verifyForm.validate((valid) => {
        if (valid) {
          this.confirmVerification();
        }
      });
    },
    confirmVerification() {
      this.loading = true;
      this.userProvider.confirmVerification(this.user).then(() => {
        this.loading = false;
        this.showSuccessMsg('User verified');
        this.$router.push('/signin');
      }).catch((error) => {
        this.loading = false;
        this.showErrorMsg(error);
      });
    },
    onResend() {
      this.userProvider.resendVerificationCode(this.user).then(() => {
        this.showSuccessMsg('Verification code send to your email');
      }).catch((error) => {
        this.showErrorMsg(error);
      });
    },
  },
};
</script>

<style lang="scss">
.verification-page {
}
</style>



// WEBPACK FOOTER //
// app/src/pages/onboarding/Verify.vue